module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3LjU0IDYuODEiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojY2YxZjJlO308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTAsMy40MSwyLjU2LDBINC4xM0wxLjYyLDMuNDFsMi41MSwzLjRIMi41NlptMy40MSwwTDYsMEg3LjU0TDUsMy40MWwyLjUxLDMuNEg2WiIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newImages/left-red-arrow.svg
// module id = 1035
// module chunks = 173